import { EnquiriesSelect } from '../../../components/Sales/Quotes/AddQuote/AddQuote'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import CustomSelect from '../../../elements/Select/CustomSelect'
import GroupsSelect from '../../../elements/Select/Groups/GroupsSelect'
import withData from '../../../elements/Select/withData'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import { dateVal } from '../../../modules/Utils'
import moment from 'moment'
import React from 'react'
import { Checkbox, Col, DatePicker, Form, Input, Radio, Row, TimePicker } from 'antd'
import { get, isEmpty } from 'lodash'

import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import CustomSpin from '../../../elements/CustomSpin'
import { compose } from 'recompose'
import Authentication from '../../../modules/Authentication'

const { TextArea } = Input

const auth = new Authentication()

const TimezoneSelect = compose(
  withSelectFetch({
    dropdown: 'general',
    name: 'timezones',
  }),
  withSpinning,
  withSort,
)(CustomSelect)

const TaskTypeSelect = compose(
  withData({
    data: [
      // {key: 'note', value: 'Note'},
      { key: 'toDo', value: 'To Do' },
      // {key: 'callBack', value: 'Call Back'},
    ],
  }),
  withSort,
)(CustomSelect)

const TagSelect = compose(
  withData({
    data: [
      { key: 'Today', value: 'Today', color: '#2db7f5' },
      { key: 'Urgent', value: 'Urgent', color: '#f50' },
    ],
  }),
  withSort,
)(CustomSelect)

const StateSelect = compose(
  withData({
    data: [
      { key: 'Todo', value: 'Todo' },
      { key: 'Doing', value: 'Doing' },
      { key: 'BackLog', value: 'BackLog' },
      { key: 'Done', value: 'Done' },
      { key: 'Archived', value: 'Archived' },
    ],
  }),
  withSort,
)(CustomSelect)

function TaskSystemForm (props) {
  const { task, isNew, fetching, enquiryID } = props
  console.log({ enquiryID })
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form

  const isSale = getFieldValue('type') === 'Sales'
  const isInternal = getFieldValue('type') === 'Internal'

  const enquiryId = getFieldValue('enquiry._id') || ''

  const [SalesOrderSelect] = useFetchSelectUrl(
    {
      name: 'salesOrder',
      url: `enquiries/${(enquiryId || '').replace('activities/', '')}/salesOrder`,
      cache: false,
    },
    [enquiryId],
    isEmpty(enquiryId),
    undefined,
    enquiry => ({
      ...enquiry,
      display: `${enquiry.code} - ${enquiry.title}`,
    }),
  )

  const group = getFieldValue('group._id') || ''
  const [EmployeesSelect] = useFetchSelectUrl(
    {
      name: 'employees',
      url: `groups/${group.replace('groups', '')}/links`,
      cache: false,
    },
    [group],
    isEmpty(group),
    undefined,
    group => ({
      ...group,
      display: `${group.code} - ${group.title}`,
    }),
  )

  return (
    <Form>
      <CustomSpin spinning={fetching}>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Activity Type">
              {getFieldDecorator('type', {
                initialValue: get(task, 'type') || 'Sales',
                /*? 'Sales'
                : 'Internal',*/
              })(
                <Radio.Group>
                  <Radio.Button value="Internal">Internal</Radio.Button>
                  <Radio.Button value="Sales">Sales</Radio.Button>
                  <Radio.Button value="Personal" disabled>
                    Personal
                  </Radio.Button>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Department">
              {getFieldDecorator('group._id', {
                initialValue: get(task, 'group._id'),
                rules: rules.select,
              })(<GroupsSelect/>)}
            </Form.Item>
          </Col>

          {group && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Assigned To">
                {getFieldDecorator('assignedTo._id', {
                  initialValue: get(task, 'assignedTo._id'),
                })(
                  <EmployeesSelect
                    placeholder={'Select a Employee'}
                    keyAtr={'member._id'}
                    valueAtr={'member.fn'}
                  />,
                )}
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          {isSale && (
            <fragment>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Enquiry">
                  {getFieldDecorator('enquiry._id', {
                    initialValue: get(task, 'enquiry._id') || enquiryID,
                    rules: rules.select,
                  })(
                    <EnquiriesSelect
                      keyAtr={'_id'}
                      valueAtr={'display'}
                      placeholder={'Select an enquiry'}
                    />,
                  )}
                </Form.Item>
              </Col>
              {enquiryId && (
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Sales Order">
                    {getFieldDecorator('order._id', {
                      initialValue: get(task, 'order._id'),
                      //rules: rules.select,
                    })(
                      <SalesOrderSelect
                        keyAtr={'_id'}
                        valueAtr={'display'}
                        placeholder={'Select an Sales Order'}
                      />,
                    )}
                  </Form.Item>
                </Col>
              )}
            </fragment>
          )}
        </Row>
        <FormSectionTitle title={'TASK DETAILS'}/>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Task Type">
              {getFieldDecorator('taskType', {
                initialValue: get(task, 'taskType') || 'To Do',
                rules: rules.select,
              })(<TaskTypeSelect/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Tags">
              {getFieldDecorator('tag', {
                initialValue: get(task, 'tag'),
                //rules: rules.select,
              })(<TagSelect mode="multiple"/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Title">
              {getFieldDecorator('title', {
                initialValue: get(task, 'title'),
                rules: rules.input,
              })(<Input placeholder="Title"/>)}
            </Form.Item>
            <Form.Item {...defaultFormItemLayout} label="Description">
              {getFieldDecorator('description', {
                initialValue: get(task, 'description'),
              })(<TextArea rows={5}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Created on">
              {getFieldDecorator('created.date', {
                initialValue: dateVal(task, 'created.date') || moment(),
                rules: rules.select,
              })(<DatePicker disabled style={{ width: '100%' }}/>)}
            </Form.Item>
            <Form.Item {...defaultFormItemLayout} label="Complete By">
              {getFieldDecorator('due.date', {
                initialValue: dateVal(task, 'due.date'),
                rules: rules.select,
              })(
                <DatePicker
                  style={{ width: '100%' }}
                  onChange={value => {
                    if (value) {
                      const newV = moment(value.format()).subtract(3, 'days')
                      setFieldsValue({ followupDate: newV })
                    }
                  }}
                />,
              )}
              {getFieldDecorator('due.time', {
                initialValue: dateVal(task, 'due.time'),
              })(<TimePicker defaultOpenValue={moment('00:00:00', 'HH:mm:ss')}/>)}
              {getFieldDecorator('due.timezone', {
                initialValue: get(task, 'due.timezone'),
              })(
                <TimezoneSelect
                  placeholder={'Select a timezone'}
                  keyAtr={'text'}
                  valueAtr={'text'}
                />,
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="State">
              {getFieldDecorator('state', {
                initialValue: get(task, 'state') || 'Todo',
                rules: rules.select,
              })(<StateSelect/>)}
            </Form.Item>
          </Col>
          <Col span={12} style={{ align: 'center' }}>
            <Form.Item
              {...defaultFormItemLayout}
              label="Send Notification"
              style={{ fontWeight: 'bold', color: 'red' }}>
              {getFieldDecorator('sendEmail', {
                valuePropName: 'checked',
              })(<Checkbox/>)}
            </Form.Item>
          </Col>
        </Row>
      </CustomSpin>
    </Form>
  )
}

TaskSystemForm.propTypes = {}
TaskSystemForm.defaultProps = {}

export default Form.create()((TaskSystemForm))
